
export const MenuLabel = {
  memory : "Memòria",
  execusio : "Execució",
  justificacio_tecnica : "Justificació tècnica",
  justificacio_economica : "Justificació econòmica",
  finalitzar : "Finalitzar",
  impacte : "Impacte",
}

export const MenuIcon = {
  memory : "description",
  execusio : "open_in_new",
  justificacio_tecnica : "add_task",
  justificacio_economica : "fact_check",
  finalitzar : "assistant_photo",
  impacte : "exposure",
}
